@use '../../../app/styles/common/mixins';

.contacts {
  display: flex;
  gap: var(--spasing06);
}

.button {
  white-space: nowrap;

  @include mixins.heading-secondary-100;
}
